import { CurecallSearchInput } from '@honestica/curecall-ui'
import { useTranslation } from 'react-i18next'
import { useCurrentProject } from 'src/providers/current-project.provider'
import { useSearch } from './use-search.hook'
import SearchbarResults from './searchbar-results.component'

const Searchbar = () => {
  const { t } = useTranslation()
  const { project } = useCurrentProject()
  const {
    showResults,
    searchValue,
    searchbarRef,
    resultsContainerRef,
    searchResults,
    cursorIndex,
    handleSearchChange,
    handleOnFocus,
    handleKeyDown,
    clearField,
  } = useSearch()

  return (
    <CurecallSearchInput
      clearButtonAriaLabel={t('components.navigation.header.empty-search-field')}
      placeholder={t('components.navigation.header.find-a-patient', { projectName: project.name })}
      searchInputAriaLabel={t('components.navigation.header.search-input-label')}
      onChange={handleSearchChange}
      onFocus={handleOnFocus}
      onClear={clearField}
      value={searchValue}
      onKeyDown={handleKeyDown}
      ref={searchbarRef}
      autoComplete="off"
    >
      {showResults && (
        <SearchbarResults
          searchResults={searchResults}
          cursorIndex={cursorIndex}
          projectId={project.id}
          clearField={clearField}
          searchValue={searchValue}
          resultsContainerRef={resultsContainerRef}
        />
      )}
    </CurecallSearchInput>
  )
}

export default Searchbar
